import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';
import { ECustomerTypeView } from '../store/ducks/user/types';
import { hasOnlyCGCustomerTypes } from '../utils/commerceUser';
import { GetFlag } from '../utils/featureFlag';
import useIsCommerceUser from './useIsCommerceUser';

const useCanGoToPurchase = (): boolean => {
  const isManager = useSelector(
    (state: ApplicationState) => state.user.isManager
  );
  const customerViewType = useSelector(
    (state: ApplicationState) => state.user.searchCustomerType
  );
  const userPermissions = useSelector(
    (state: ApplicationState) => state.user.userPermissions
  );
  const journeyViews = useSelector(
    (state: ApplicationState) => state.user.journeyViews
  );
  const customers = useSelector(
    (state: ApplicationState) => state.customers.customers
  );
  const customersLoading = useSelector(
    (state: ApplicationState) => state.customers.loading
  );
  const businessType = useSelector(
    (state: ApplicationState) => state.user.businessType
  );
  const isMVPUser = useIsCommerceUser();
  const migrationFlag = GetFlag('purchase-migration-brdi-brin');

  const isEmitter = customerViewType === ECustomerTypeView.EMITTER;
  const isFabricationReceiver =
    customerViewType === ECustomerTypeView.FABRICATION_RECEIVER;
  const hasCommerceMagento =
    !(migrationFlag && businessType === 'CG') &&
    (journeyViews?.includes('commerce_magento') ?? false);
  const isMigrationMVPUser =
    !hasCommerceMagento && !customersLoading && isMVPUser;
  const isCGOnlyWithFabricationAccess =
    migrationFlag &&
    !customersLoading &&
    isEmitter &&
    hasOnlyCGCustomerTypes(customers) &&
    userPermissions.hasFabricationAccess;

  return (
    isManager ||
    (isEmitter &&
      userPermissions.hasOrderInputAccess &&
      (hasCommerceMagento || isMigrationMVPUser)) ||
    (isFabricationReceiver && userPermissions.hasFabricationAccess) ||
    !!isCGOnlyWithFabricationAccess
  );
};

export default useCanGoToPurchase;
